// Week 10 / Day 4 — Ideas Light: Business, Company and Risk (bilingual RU/EN inline).
// Quest-style, playful review of Weeks 7–8. Educational only — paper portfolio, no real investing.

export const maxWeek10Day4 = {
  id: 'max-week-10-day-4',
  studentId: 'max',
  weekId: 'week-10',
  dayId: 'day-4',
  title: 'Огонёк идей: бизнес, компания и риск / Ideas Light: Business, Company and Risk',
  shortTitle: 'Огонёк идей / Ideas Light',
  theme:
    'Нимни вспоминает: хорошая идея должна быть полезной, честной и продуманной. / Nimny remembers: a good idea should be useful, honest and thoughtful.',
  estimatedTimeLabel:
    'Квестовая часть: около 20–30 минут. Паспорт миссии и короткая проверка с родителем: около 35–50 минут. / Quest part: about 20–30 minutes. Mission passport and short parent check: about 35–50 minutes.',
  nimnyIntro:
    'Четвёртый огонёк спрятан в мастерской идей. Чтобы его зажечь, нужно вспомнить профессию, продукт, услугу, цену, прибыль, компанию и риск. / The fourth light is hidden in the workshop of ideas. To light it, remember profession, product, service, price, profit, company and risk.',
  goals: [
    'Огонёк знаний № 4: идея, продукт, услуга, прибыль, компания, риск. / Light of knowledge #4.',
    'Слой 1. Математика / Layer 1. Math: расходы, выручка, прибыль, сравнение, доли портфеля (Grade 5 / middle).',
    'Слой 2. Русский язык / Layer 2. Russian: словарь огонька идей и мини-диктант.',
    'Слой 3. Чтение и короткое письмо / Layer 3. Reading and short writing: 3–5 предложений «Почему хорошая идея должна быть полезной и честной?».',
    'Слой 4. Карточки идей / Layer 4. Idea cards: продукт / услуга / расход / выручка / риск / честное объяснение.',
    'Слой 5. Паспорт миссии / Layer 5. Mission passport: безопасные правила и рисунок огонька. / Safe statements and the fourth light drawing.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'профессия / profession', definition: 'дело, которому учатся / a craft people learn' },
    { term: 'продукт / product', definition: 'вещь, которую можно использовать / a thing to use' },
    { term: 'услуга / service', definition: 'помощь или работа для другого / help or work for someone' },
    { term: 'покупатель / customer', definition: 'тот, кому нужна польза / one who needs the benefit' },
    { term: 'цена / price', definition: 'сколько стоит / how much it costs' },
    { term: 'выручка / revenue', definition: 'нимы пришли от покупателей / nims received from customers' },
    { term: 'расход / expense', definition: 'нимы ушли на материалы / nims spent on materials' },
    { term: 'прибыль / profit', definition: 'выручка минус расходы / revenue minus expenses' },
    { term: 'компания / company', definition: 'группа людей, делающих продукт или услугу / a group making a product or service' },
    { term: 'риск / risk', definition: 'возможность другого результата / chance of a different result' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Сколько всего расходов? / Total expenses?',
      prompt: 'Материалы 12 нимов, упаковка 4 нима. Сколько всего? / Materials 12, packaging 4. Total?',
      helper: '12 + 4. / 12 + 4.', answer: '16', unit: 'нимов / nims' },
    { id: 'q2', type: 'math', title: 'Выручка проекта / Project revenue',
      prompt: '6 штук по 8 нимов. Сколько выручки? / 6 items × 8 nims each. Revenue?',
      helper: '6 × 8. / 6 × 8.', answer: '48', unit: 'нимов / nims' },
    { id: 'q3', type: 'math', title: 'Прибыль / Profit',
      prompt: 'Выручка 48 нимов, расходы 28 нимов. Какая прибыль? / Revenue 48, expenses 28. Profit?',
      helper: '48 − 28. / 48 − 28.', answer: '20', unit: 'нимов / nims' },
    { id: 'q4', type: 'math', title: 'У какой компании прибыль больше? / Which company has bigger profit?',
      prompt: 'Компания A: выручка 60, расходы 35. Компания B: выручка 55, расходы 25. У кого прибыль больше? / A: 60−35; B: 55−25. Bigger profit?',
      helper: 'Посчитай каждую прибыль. / Calculate each profit.', answer: 'A: 60 − 35 = 25; B: 55 − 25 = 30. Прибыль больше у компании B (30). / B (30).' },
    { id: 'q5', type: 'math', title: 'Самая большая часть портфеля / Largest portfolio part',
      prompt: 'Бумажный портфель 100 нимов: 40, 30, 30. Какая часть самая большая? / Paper portfolio 100: 40, 30, 30. Largest?',
      helper: 'Сравни 40, 30, 30. / Compare.', answer: '40', unit: 'нимов / nims' },
    { id: 'q6', type: 'classify', title: 'Карточки идей / Idea cards',
      prompt: 'Распредели карточки по 6 домикам. / Sort the cards into 6 houses.',
      categories: [
        { id: 'product', label: 'Продукт / Product' },
        { id: 'service', label: 'Услуга / Service' },
        { id: 'expense', label: 'Расход / Expense' },
        { id: 'revenue', label: 'Выручка / Revenue' },
        { id: 'risk', label: 'Риск / Risk' },
        { id: 'honest', label: 'Честное объяснение / Honest explanation' }
      ],
      items: [
        { id: 'bookmark', text: 'закладка / a bookmark' },
        { id: 'cleaning', text: 'помощь с уборкой / help with cleaning' },
        { id: 'materials', text: 'материалы стоят 12 нимов / materials cost 12 nims' },
        { id: 'got40', text: 'получили 40 нимов выручки / received 40 nims of revenue' },
        { id: 'idea_risk', text: 'идея может не понравиться покупателю / idea may not please the customer' },
        { id: 'honest_q', text: 'объяснить качество честно / explain quality honestly' },
        { id: 'all_in_one', text: 'вложить всё в одну идею / put everything into one idea' },
        { id: 'compare', text: 'сравнить несколько вариантов / compare several options' }
      ] },
    { id: 'q7', type: 'classify', title: 'Какие правила инвестирования безопасные? / Which investing rules are safe?',
      prompt: 'Распредели утверждения. / Sort the statements.',
      categories: [
        { id: 'safe', label: 'Безопасное правило / Safe rule' },
        { id: 'unsafe', label: 'Небезопасно / Unsafe' }
      ],
      items: [
        { id: 'sim', text: 'Это учебная симуляция. / This is a paper simulation.' },
        { id: 'fast', text: 'Можно обещать быстрый рост. / Promise quick growth.' },
        { id: 'risk_known', text: 'Риск нужно понимать. / Risk must be understood.' },
        { id: 'div', text: 'Не всё в одну идею. / Not everything in one idea.' },
        { id: 'check_info', text: 'Нужно проверять информацию. / Information must be checked.' },
        { id: 'real_account', text: 'Открыть настоящий счёт самому. / Open a real account by myself.' }
      ] },
    { id: 'q8', type: 'text', title: 'Исправь ошибки / Fix the mistakes',
      prompt: 'Перепиши без ошибок и расставь знаки: «харошая идея должна быть полезной и чесной перед проектом нужна посчитать расходы и прибыль». / Rewrite without mistakes (Russian sentence above).',
      placeholder: 'Хорошая идея должна быть полезной и честной. / A good idea should be useful and honest.' },
    { id: 'q9', type: 'essay', title: 'Почему хорошая идея должна быть полезной и честной? / Why should a good idea be useful and honest?',
      prompt: 'Напиши 3–5 предложений по-русски. Используй слова: продукт, услуга, прибыль, риск, честный. / Write 3–5 Russian sentences using the keywords.',
      minSentences: 3, maxSentences: 5, placeholder: 'Хорошая идея должна быть полезной, потому что... / A good idea should be useful because...' },
    { id: 'q10', type: 'essay', title: 'Тихий вопрос Нимни / A quiet question from Nimny',
      prompt: 'Напиши 2–4 предложения: какую идею ты бы сделал? Используй слово «огонёк». / Write 2–4 sentences about an idea you would make; use "огонёк".',
      minSentences: 2, maxSentences: 4, placeholder: 'Я бы сделал идею про... / I would make an idea about...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 10, День 4 — Огонёк идей». / Heading: "Week 10, Day 4 — Ideas Light".',
    'Слой 1. Математика / Layer 1. Math: q1–q5 + опц. 25/100 = 1/4. / + optional fraction.',
    'Слой 2. Русский язык / Layer 2. Russian: словарь и мини-диктант: «Хорошая идея должна быть полезной и честной. Перед проектом нужно посчитать расходы и прибыль.» + правка. / vocabulary, mini-dictation, edit.',
    'Слой 3. Чтение и короткое письмо / Layer 3. Reading and short writing: 3–5 предложений «Почему хорошая идея должна быть полезной и честной?». / 3–5 sentences.',
    'Слой 4. Карточки идей / Layer 4. Idea cards: 8 карточек по 6 домикам + 6 правил безопасности. / 8 idea cards + 6 safety rules.',
    'Слой 5. Паспорт миссии / Layer 5. Mission passport: рисунок четвёртого огонька. / Fourth-light drawing.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами после проверки. / Reward in nims after parent check.'
  ],
  printWorksheet: {
    title: 'Неделя 10, День 4 / Week 10, Day 4',
    subtitle: 'Огонёк идей: бизнес, компания и риск / Ideas Light: Business, Company and Risk',
    pages: [
      { title: 'Маршрут миссии / Mission route', blocks: [
        { type: 'text', text: 'Поставь штамп ✦, когда выполнено. / Stamp ✦ when done.' },
        { type: 'list', items: [
          '✦ 1. Быстрая математика / Quick math.',
          '✦ 2. Русский язык — слова и мини-диктант / Russian — words and mini-dictation.',
          '✦ 3. Короткое письмо «Почему идея должна быть полезной и честной?» / Short writing.',
          '✦ 4. Карточки идей / Idea cards.',
          '✦ 5. Безопасные правила инвестирования и рисунок огонька / Safe rules and light drawing.',
          '✦ 6. Дневник мышления / Thinking diary.',
          '✦ 7. Проверка с родителем / Parent check.',
          '✦ 8. Печать миссии и нимы / Mission stamp and nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика — быстрая миссия / Layer 1. Math — Quick mission', blocks: [
        { type: 'list', items: [
          '1) 12 + 4 = ____ нимов всего расходов / total expenses.',
          '2) 6 × 8 = ____ нимов выручки / nims revenue.',
          '3) 48 − 28 = ____ нимов прибыли / nims profit.',
          '4) Прибыль / Profit: A: 60 − 35 = ____ ; B: 55 − 25 = ____ ; больше у ____ / bigger at ___.',
          '5) Самая большая часть портфеля 40 / 30 / 30: ____ нимов / largest portfolio part.',
          '6) Optional / Доп.: 25 / 100 = ____ (упрости) / Simplify.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык — слова и мини-диктант / Layer 2. Russian — Words and Mini-Dictation', blocks: [
        { type: 'text', text: 'Лёгкое повторение: словарь огонька идей. / Light review: ideas-light vocabulary.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: профессия, продукт, услуга, покупатель, цена, выручка, расход, прибыль, компания, риск.',
          'Мини-диктант / Mini-dictation: «Хорошая идея должна быть полезной и честной. Перед проектом нужно посчитать расходы и прибыль.»',
          'Исправь ошибки / Fix mistakes: «харошая идея должна быть полезной и чесной перед проектом нужна посчитать расходы и прибыль».',
          'Орфограмма дня / Spelling rule of the day: безударные гласные и парные согласные. / Unstressed vowels and paired consonants.'
        ] }
      ] },
      { title: 'Слой 3. Чтение и короткое письмо / Layer 3. Reading and Short Writing', blocks: [
        { type: 'list', items: [
          'Прочитай ещё раз слова огонька идей. / Re-read the ideas-light vocabulary.',
          'Напиши 3–5 предложений «Почему хорошая идея должна быть полезной и честной?» / Write 3–5 Russian sentences "Why should a good idea be useful and honest?": ____________________________________________',
          'Используй слова: продукт, услуга, прибыль, риск, честный / Use the keywords.'
        ] }
      ] },
      { title: 'Слой 4. Карточки идей и сортировка / Layer 4. Idea Cards and Sorting', blocks: [
        { type: 'text', text: 'Вырежи или отметь карточки и положи в 6 домиков. / Cut or mark cards and place into 6 houses.' },
        { type: 'list', items: [
          '«закладка» → ▢ Продукт ▢ Услуга ▢ Расход ▢ Выручка ▢ Риск ▢ Честное объяснение',
          '«помощь с уборкой» → ▢ … ▢ Услуга ▢ … ▢ … ▢ … ▢ …',
          '«материалы стоят 12 нимов» → ▢ … ▢ … ▢ Расход ▢ … ▢ … ▢ …',
          '«получили 40 нимов выручки» → ▢ … ▢ … ▢ … ▢ Выручка ▢ … ▢ …',
          '«идея может не понравиться покупателю» → ▢ … ▢ … ▢ … ▢ … ▢ Риск ▢ …',
          '«объяснить качество честно» → ▢ … ▢ … ▢ … ▢ … ▢ … ▢ Честное объяснение',
          '«вложить всё в одну идею» → ▢ … ▢ … ▢ … ▢ … ▢ Риск ▢ …',
          '«сравнить несколько вариантов» → ▢ … ▢ … ▢ … ▢ … ▢ … ▢ Честное объяснение'
        ] }
      ] },
      { title: 'Слой 5. Огонёк знаний — безопасные правила и рисунок / Layer 5. Knowledge Light — Safe Rules and Drawing (practical)', blocks: [
        { type: 'text', text: 'Только учебная симуляция. Никаких реальных вложений, торговли или рекомендаций. / Educational simulation only. No real investing, trading or recommendations.' },
        { type: 'list', items: [
          'Безопасные правила / Safe rules: ▢ Это учебная симуляция. ▢ Риск нужно понимать. ▢ Не всё в одну идею. ▢ Нужно проверять информацию.',
          'Небезопасно / Unsafe: ▢ Можно обещать быстрый рост. ▢ Открыть настоящий счёт самому.',
          'Рисунок огонька идей / Ideas-light drawing: ▢▢▢',
          'Подпись / Caption: «Я умею думать об идее честно.»'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что было самым весёлым в четвёртой миссии? / Most fun in mission #4: ___________________',
          'Что было самым важным? / Most important: ___________________'
        ] }
      ] },
      { title: 'Родительская проверка, печать миссии и награда нимами / Parent check, mission stamp and reward in nims', blocks: [
        { type: 'list', items: [
          'Печать миссии / Mission stamp: ▢ ✦ ОГОНЁК ИДЕЙ ЗАЖЖЁН ✦ / IDEAS LIGHT IS LIT.',
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за точные расчёты идеи / Bonus for accurate idea math: +1 ☐',
          'Бонус за честное объяснение идеи / Bonus for an honest idea explanation: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Лёгкая квестовая миссия: повторить идеи Недель 7–8 (профессия, продукт, услуга, цена, выручка, расход, прибыль, компания, риск, диверсификация). Самостоятельная работа; роль родителя — короткое введение (3–5 минут), помощь только если ребёнок застрял, и финальная проверка (5–10 минут). Не экзамен. / Light quest mission reviewing Weeks 7–8. Child-led; parent gives 3–5 min intro, helps only if stuck, 5–10 min final check. Not a test.',
    safetyNote: 'Только учебная симуляция в нимах. Никаких реальных вложений, торговли, открытия счетов или рекомендаций. / Educational simulation only. No real investing, trading, opening accounts or recommendations.',
    mathGoal: 'q1: 12+4 = 16. q2: 6×8 = 48. q3: 48−28 = 20. q4: A 25, B 30; больше у B. q5: 40 нимов. Опц.: 25/100 = 1/4. / Listed.',
    russianGoal: 'Словарь огонька идей запомнен; мини-диктант чистый; правка корректна. / Vocabulary recalled; clean dictation; edit correct.',
    readingWritingGoal: '3–5 предложений по-русски с минимум 3 ключевыми словами. / 3–5 Russian sentences using ≥ 3 keywords.',
    missionGoal: '8 карточек идей распределены по 6 домикам без явных ошибок (некоторые карточки могут попасть в 1–2 категории). / 8 idea cards sorted; some cards may fit 2 houses.',
    practicalGoal: '4 безопасных правила выбраны корректно, 2 небезопасных отделены. Никаких реальных счетов или торговли. / 4 safe rules selected; 2 unsafe separated.',
    check: [
      'Q1: 16 нимов / 16 nims.',
      'Q2: 48 нимов / 48 nims.',
      'Q3: 20 нимов / 20 nims.',
      'Q4: больше у B (30) / B (30).',
      'Q5: 40 нимов / 40 nims.',
      'Карточки идей разложены / Idea cards sorted.',
      '4 безопасных правила выбраны / 4 safe rules selected.',
      '3–5 предложений «Почему идея должна быть полезной и честной?» / 3–5 sentences.'
    ],
    answerKey: [
      { taskId: 'q1', answer: '12 + 4 = 16 нимов всего расходов. / 16 nims.' },
      { taskId: 'q2', answer: '6 × 8 = 48 нимов выручки. / 48 nims.' },
      { taskId: 'q3', answer: '48 − 28 = 20 нимов прибыли. / 20 nims.' },
      { taskId: 'q4', answer: 'A: 60 − 35 = 25; B: 55 − 25 = 30. Прибыль больше у компании B (30 нимов). / B (30).' },
      { taskId: 'q5', answer: '40 нимов — самая большая часть портфеля 40/30/30. / 40 nims.' },
      { taskId: 'q6', answer: 'Продукт: закладка. Услуга: помощь с уборкой. Расход: материалы стоят 12 нимов. Выручка: получили 40 нимов выручки. Риск: идея может не понравиться, вложить всё в одну идею. Честное объяснение: объяснить качество честно, сравнить несколько вариантов. / Listed.' },
      { taskId: 'q7', answer: 'Безопасные правила: учебная симуляция, риск нужно понимать, не всё в одну идею, нужно проверять информацию. Небезопасно: обещать быстрый рост, открыть настоящий счёт самому. / Listed.' },
      { taskId: 'q8', answer: 'Хорошая идея должна быть полезной и честной. Перед проектом нужно посчитать расходы и прибыль.' },
      { taskId: 'q9', answer: 'Открытый ответ. 3–5 предложений с идеей: продукт или услуга должны решать настоящую задачу, объяснение должно быть честным, нужно учесть риск. / Open answer.' },
      { taskId: 'q10', answer: 'Открытый ответ. 2–4 предложения; идея простая и полезная; слово «огонёк» использовано. / Open answer.' }
    ],
    spellingCheck: 'Словарь и диктант чистые; правка корректна. / Vocabulary recalled; clean dictation; edit correct.',
    readingCheck: '3–5 предложений по-русски; ключевые слова использованы. / 3–5 Russian sentences with keywords.',
    missionCheck: '8 карточек идей и 6 правил безопасности распределены без явных ошибок. / 8 idea cards and 6 safety rules sorted.',
    notebookCheck: 'Дневник мышления заполнен; рисунок огонька подписан. / Diary filled; light drawing signed.',
    printCheck: 'Все 8 страниц паспорта миссии заполнены. / All 8 mission-passport pages completed.',
    discussionPrompts: [
      'Что такое продукт? / What is a product?',
      'Что такое услуга? / What is a service?',
      'Что такое прибыль? / What is profit?',
      'Что такое риск? / What is risk?',
      'Почему важна честность? / Why is honesty important?'
    ],
    parentRoleNote: 'Введение 3–5 минут, помощь только если застрял, финальная проверка 5–10 минут и начисление нимов. Не экзамен. / 3–5 min intro, help only if stuck, 5–10 min final check, then award nims. Not a test.',
    ifEasy: 'Усложните: пусть ребёнок придумает свою фиктивную компанию из 3 пунктов и посчитает прибыль. / Make harder: invent a 3-line fictional company and compute its profit.',
    ifDifficult: 'Сократите: оставьте q1, q3, q6 (4 карточки) и рисунок огонька. / Make easier: keep q1, q3, q6 (4 cards) and the light drawing.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / After checking the work, the parent may add bonus nims through Parent Room. Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за миссию / Mission reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'idea-math', label: 'Бонус за точные расчёты идеи / Bonus for accurate idea math', amount: 1 },
      { id: 'honest-idea', label: 'Бонус за честное объяснение идеи / Bonus for an honest idea explanation', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q6', 'q7', 'q9', 'q10'], allowNotebookCompletion: true },
  nextLessonId: 'max-week-10-day-5'
};

export default maxWeek10Day4;
